import { endOfDay, isValid, isWithinInterval, parseISO, startOfDay } from 'date-fns'

export interface SnowSeason {
  openDate: Date
  closeDate: Date
}

export function getSnowSeason(openDate: string | null, closeDate: string | null): SnowSeason | null {
  if (!openDate || !closeDate)
    return null

  const parsedOpenDate = parseISO(openDate)
  const parsedCloseDate = parseISO(closeDate)

  if (!isValid(parsedOpenDate) || !isValid(parsedCloseDate))
    return null

  if (startOfDay(parsedOpenDate) > endOfDay(parsedCloseDate))
    return null

  return {
    openDate: parsedOpenDate,
    closeDate: parsedCloseDate,
  }
}

export function isResortOpen(openDate: string | null, closeDate: string | null, currentDate: Date): boolean {
  const snowSeason = getSnowSeason(openDate, closeDate)

  if (!snowSeason || !isValid(currentDate))
    return false

  return isWithinInterval(currentDate, {
    start: startOfDay(snowSeason.openDate),
    end: endOfDay(snowSeason.closeDate),
  })
}
